import * as React from "react"
import { Box, Grid, Skeleton } from "@mui/material"
import { CardSeeker } from "@ui-seeker/core"
import { generateColor } from "@ui-seeker/utils"

import { TitleWithPopover } from "@components"
import { BORDER_COLOR, BORDER_STYLE, COLORS } from "@constants"
import { usePriceDiscountCandlestickData } from "./@hooks"
import PricingCandlestickChartBlock from "./ChartBlock"
import PricingCandlestickLabelBlock from "./LabelBlock"
import PricingCandlestickLegend from "./Legend"
import PricingCandlestickModal from "./Modal"
import PriceDiscountGroupedByToggleButton from "../GroupedByToggleBtn"
import { usePricingDiscountRoleConfig } from "../../@hooks"


const styles = {
	borderBottom: BORDER_STYLE,
	borderBottomColor: BORDER_COLOR
}

export default function PriceDiscountCandlestick() {
	const { data, isLoading, rowHeight, maxDiscount, minDiscount } = usePriceDiscountCandlestickData()
	const { typeKpi } = usePricingDiscountRoleConfig()

	if (isLoading) return <Skeleton variant="rectangular" height={450} />
	if (!data.length) return <></>

	return <CardSeeker title={<TitleWithPopover title={`${typeKpi} Overview`} />} actions={<PriceDiscountGroupedByToggleButton />}>
		<Box sx={{ borderTop: BORDER_STYLE, borderTopColor: BORDER_COLOR }}>
			{ data.slice(0, 10).map(({ discounts, groupedID, externalSeller, ...config }, idx) => {
				const color = COLORS[idx] || generateColor()

				return <Grid container spacing={0} key={idx} sx={{ ...styles, minHeight: 55, height: rowHeight + 10 }}>
					<Grid item xs={2}>
						<PricingCandlestickLabelBlock 
							totalWithoutDiscount={config?.percentageWithoutDiscount}
							totalProducts={config?.totalSkus}
							{...config}
						/>
					</Grid>

					<Grid item xs={10}>
						<PricingCandlestickChartBlock
							discounts={discounts}
							color={color}
							externalSeller={externalSeller}
							rowHeight={rowHeight > 10 ? rowHeight : 10}
							minDiscount={minDiscount}
							maxDiscount={maxDiscount}
							groupedID={groupedID}
						/>
					</Grid>
				</Grid>
			}) }
		</Box>
		<PricingCandlestickLegend
			minDiscount={minDiscount}
			maxDiscount={maxDiscount}
		/>

		<PricingCandlestickModal />
	</CardSeeker>
}